import './App.css'
import React from 'react'
import { Route, Routes } from 'react-router-dom'

import PokemonPage from './pages/pokemonpage/PokemonPage'

function App () {
  return (
    <Routes>
      {/* 🔹 Page par défaut */}
      <Route path='/' element={<PokemonPage />} />


    </Routes>
  )
}

export default App
